document.querySelectorAll( '.b-post-share-button' ).forEach( ( block ) => {

	const shareData = {
		title: block.getAttribute( 'data-post-title' ),
		url: block.getAttribute( 'data-url' ),
	};

	if ( navigator.share && navigator.canShare( shareData ) ) {

		block.addEventListener( 'click', async () => {

			try {

				await navigator.share( shareData );

			} catch ( err ) {


			}

		} );

	} else {

		block.classList.add( 'c-button--hidden' )

	}

} );
